// `overflow: hidden` alone doesn't stop iOS Safari from panning the layout viewport
// when a focused input lives inside a `position: fixed` element (it scrolls to keep
// the input in view). Freezing the body at its current scroll position prevents that.
// Reference-counted so stacked modals (e.g. Loading over Auth) don't unlock each other.
//
// JS only measures the scroll offset and toggles a class; the actual layout (the
// `position: fixed` / `top` / `width` rules) lives in CSS — see the `.scroll-locked`
// rule in modal.svelte's <style> block.
let lockCount = 0;
let savedScrollY = 0;
export function lockBodyScroll() {
    if (lockCount === 0) {
        savedScrollY = window.scrollY;
        document.documentElement.style.setProperty('--scroll-lock-offset', `-${savedScrollY}px`);
        document.documentElement.classList.add('scroll-locked');
    }
    lockCount++;
}
export function unlockBodyScroll() {
    if (lockCount === 0)
        return;
    lockCount--;
    if (lockCount === 0) {
        document.documentElement.classList.remove('scroll-locked');
        window.scrollTo(0, savedScrollY);
    }
}
